/**
 * Combines a date and a time to create a new Date object.
 * If date or time is undefined, return undefined.
 * @param date The date component
 * @param time The time component
 */
export function createCompositeDateTime(date: Date | undefined, time: Date | undefined): Date | undefined {
  return date && time
    ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds())
    : undefined;
}

export function coerceDate(date: Date | string | undefined): Date | undefined {
  const newDate = new Date(date ?? '');
  return isNaN(newDate.getTime()) ? undefined : newDate;
}
